var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--decline",attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" "+_vm._s(_vm.isPrimary ? 'Decline Entire Order' : 'Decline Entire Order')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }